import _truncate from 'truncate-html';

const filters = {

  ehTruncateHTML: function (html) {
    if (!html || html == "null") return "";
    return _truncate(html, {
      length: 100,
      byWords: true,
      stripTags: true,

      decodeEntities: true,
    });
  },
  truncateHTML: function (html, stop, ellipsis) {

  if (!html || html == "null") return "";
  return _truncate(html, {
    length: stop,
    stripTags: true,
    byWords: true,
    decodeEntities: true,

    // We want to add an ellipsis to everything, so we will add it afterwards
    ellipsis:  ellipsis?ellipsis:""
  });
  },
  truncateString: function (html,stop) {

    if (!html || html == "null") return "";
    return _truncate(html, {
      length: stop,
      byWords: true,
      ellipsis:  "..."
    });
  }
};

export default filters;